/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useContext } from 'react';
import { Avatar, StyledFlex, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { differenceInCalendarDays } from 'date-fns';
import { FREE_ROOM_MESSAGE, NETWORK_ROOM_MESSAGE, SUBSCRIBED_ROOM_MESSAGE } from './room-details-footer.constants';
import { StyledAvatarName, StyledProfileLink, StyledAvatarWrapper, StyledFlexCenter, StyledInnerSection, StyledInnerSectionFull, StyledLoadingRectangle, StyledRightFlexSection, StyledSubTitle, StyledTitle, StyledWrapper } from './room-details-footer.styles';
import { RoomsDetailsFooterProps } from './room-details-footer.types';
export const RoomDetailsFooter = ({
  roomDetails,
  isLoading
}: RoomsDetailsFooterProps) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  if (isLoading) {
    return <StyledLoadingRectangle data-testid="room-skeleton" />;
  }
  const freeOrSubscribed = roomDetails?.freeToUse ? <StyledSubTitle>{FREE_ROOM_MESSAGE}</StyledSubTitle> : <StyledSubTitle>
      {SUBSCRIBED_ROOM_MESSAGE.split('PROFILE')[0]}
      <StyledProfileLink href="https://tryhackme.com/profile">profile</StyledProfileLink>{' '}
      {SUBSCRIBED_ROOM_MESSAGE.split('PROFILE')[1]}
    </StyledSubTitle>;
  const message = roomDetails?.roomType === 'network' ? <StyledSubTitle>{NETWORK_ROOM_MESSAGE}</StyledSubTitle> : freeOrSubscribed;
  const xDaysAgo = differenceInCalendarDays(Date.now(), new Date(roomDetails?.published || roomDetails?.created || Date.now()));

  // eslint-disable-next-line no-nested-ternary
  const xDaysAgoSubtext = xDaysAgo < 1 ? 'today' : xDaysAgo === 1 ? ' day ago' : ' days ago';
  return <StyledWrapper currentTheme={theme} data-sentry-element="StyledWrapper" data-sentry-component="RoomDetailsFooter" data-sentry-source-file="room-details-footer.tsx">
      <StyledFlex alignItems="start" data-sentry-element="StyledFlex" data-sentry-source-file="room-details-footer.tsx">
        <StyledInnerSectionFull data-sentry-element="StyledInnerSectionFull" data-sentry-source-file="room-details-footer.tsx">
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="room-details-footer.tsx">Created by</StyledTitle>

          <StyledFlexCenter gap="16px" data-sentry-element="StyledFlexCenter" data-sentry-source-file="room-details-footer.tsx">
            {roomDetails?.creators?.map(creator => <StyledAvatarWrapper key={creator?.username} data-testid="creator-avatar">
                <Avatar hasBorder={false} mobileSize="24px" size="24px" avatarSrc={creator.avatar} />{' '}
                <StyledAvatarName href={`https://tryhackme.com/p/${creator.username}`}>
                  {creator.username}
                </StyledAvatarName>
              </StyledAvatarWrapper>)}
          </StyledFlexCenter>
        </StyledInnerSectionFull>
        <StyledRightFlexSection data-sentry-element="StyledRightFlexSection" data-sentry-source-file="room-details-footer.tsx">
          <StyledInnerSection data-sentry-element="StyledInnerSection" data-sentry-source-file="room-details-footer.tsx">
            <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="room-details-footer.tsx">Room Type</StyledTitle>
            {message}
          </StyledInnerSection>
          <StyledInnerSection data-sentry-element="StyledInnerSection" data-sentry-source-file="room-details-footer.tsx">
            <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="room-details-footer.tsx">Users in Room</StyledTitle>
            <StyledSubTitle data-sentry-element="StyledSubTitle" data-sentry-source-file="room-details-footer.tsx">{roomDetails?.users?.toLocaleString()}</StyledSubTitle>
          </StyledInnerSection>
          <StyledInnerSection data-sentry-element="StyledInnerSection" data-sentry-source-file="room-details-footer.tsx">
            <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="room-details-footer.tsx">Created</StyledTitle>
            <StyledSubTitle data-sentry-element="StyledSubTitle" data-sentry-source-file="room-details-footer.tsx">
              {(!!roomDetails?.published || !!roomDetails?.created) && `${xDaysAgo > 0 ? xDaysAgo : ''}${xDaysAgoSubtext}`}
            </StyledSubTitle>
          </StyledInnerSection>
        </StyledRightFlexSection>
      </StyledFlex>
    </StyledWrapper>;
};